export default __webpack_public_path__ + "static/1224-de131f97ae1efb27ea0d5f002472acda.gif";